/**
 * SuccessPage Component
 *
 * Success confirmation after end user response submission
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import Button from 'components/Button';
import Text from 'components/Text';
import * as S from './styles';

const SuccessPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <S.SuccessContainer>
      <S.SuccessIcon>✅</S.SuccessIcon>

      <Text size="XXLarge" bold textAlign="center" color="green">
        Resposta Enviada!
      </Text>

      <Box mt={2} mb={3}>
        <Text size="medium" textAlign="center" color="textSecondary">
          Obrigado por fornecer suas informações. Recebemos sua resposta e faremos o pareamento com o patrocinador.
        </Text>
      </Box>

      <S.InfoBox>
        <Text size="medium" textAlign="center" color="textPrimary">
          📅 <strong>Próximos Passos:</strong>
        </Text>
        <Box mt={2}>
          <Text size="medium" textAlign="center" color="textSecondary">
            Revisaremos sua resposta e faremos o pareamento com o patrocinador com base nas necessidades de ambos.
            Você receberá uma notificação por email quando uma reunião for agendada.
          </Text>
        </Box>
      </S.InfoBox>

      <S.ButtonGroup>
        <Button variant="primary" onClick={() => navigate('/cockpit')} size="medium">
          Ir para o Painel
        </Button>
      </S.ButtonGroup>
    </S.SuccessContainer>
  );
};

export default SuccessPage;
